module.exports = __webpack_public_path__ + "static/media/galleryImg14.6a1ee2b7.jpg";